/**
 * Suggested prompts configuration for RiseAI Chat cards in welcome screen
 */

import NRRemediateIcon from '../../NRIcons/NRRemediateIcon';
import NRCredentialIcon from '../../NRIcons/NRCredentialIcon';
import NRBinaryIcon from '../../NRIcons/NRBinaryIcon';
import NRCircleCriticalIcon from '../../NRIcons/NRCircleCriticalIcon';

export const SUGGESTED_PROMPTS = [
  {
    title: 'Fix Priorities',
    text: 'What should I fix first based on exploitability, EPSS, and known exploited vulnerabilities?',
    icon: NRRemediateIcon
  },
  {
    title: 'Digging Deeper',
    text: 'Does this asset contain any exposed credentials or private keys?',
    icon: NRCredentialIcon
  },
  {
    title: 'Binary Hardening Gaps',
    text: 'Which binaries are missing critical protections like NX, PIE, RELRO, or stack canaries?',
    icon: NRBinaryIcon
  },
  {
    title: 'High-Risk Components',
    text: 'What is the highest-risk component in this asset and what is the recommended remediation plan?',
    icon: NRCircleCriticalIcon
  }
];
